import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      STEPS: [{ title: "Legg til dagligvarer" }, { title: "Godkjenn ordre" }],

      MY_SUBSCRIPTION: "Mitt abonnement",
      ADD_ADDONS: "Legg til dagligvarer",
    },

    dk: {
      STEPS: [{ title: "Tilføj specialvarer" }, { title: "Godkend ordre" }],

      MY_SUBSCRIPTION: "Mit abonnement",
      ADD_ADDONS: "Tilføj specialvarer",
    },

    se: {
      STEPS: [
        { title: "Lägg till livsmedel" },
        { title: "Bekräfta beställning" },
      ],

      MY_SUBSCRIPTION: "Min prenumeration",
      ADD_ADDONS: "Lägg till livsmedel",
    },
  } as const
)[language];
